const appSettings = {
  appName: 'FINEX',
  appVer: 'seed 27.09.21',

  company: null,
  companies: {
    'ФК АССОЦИАЦИЯ': {name: 'ФК АССОЦИАЦИЯ'}
  },
  // welcomePage: '/admin',
  // userProfilePage: './admin/profile',

  companiesConfigs: {
    'ФК АССОЦИАЦИЯ': {
      appModules: {
      }
    }
  },

  server: {
    hostName: null,
    host: null,
    hosts: {
      'ФК АССОЦИАЦИЯ': 'https://s2.rokkets.ru:1776/api/'
//      'ФК АССОЦИАЦИЯ': 'https://localhost:1776/api/'
    },

    modelsNotifierSubscription: 'system/subscribeToRoomOrModel',

    settingsResource: 'settings/findBugfixed',
    tasksModuleSettingsCriteria: '?where={"uniqueName":["tasksModuleSettings"]}',
    finixModuleSettingsCriteria: '?where={"uniqueName":["finixModuleSettings"]}',
    mainMenuPermissionsByUserGroupsCriteria: '?where={"uniqueName":["mainMenuPermissionsByUserGroups"]}',

    // {'where': '{"ID":[17,29]}'

    userResource: 'user',
    userLogin: 'user/login',
    userGetUsersListToLogin: 'user/getUsersListToLogin',
    // usersGetSalersAdminsCriteria: {'where': '{"ID":[17,29]}', 'sort': 'Name asc'},
    userGetActiveUser: 'user/getActiveUser',
    userLogout: 'user/logout',
    userActiveChangePassword: 'user/activeUserChangePassword',
    userChangeName: 'user/userChangeName',

    userGroupResource: 'userGroup',

    partnerResource: 'partner',

    newsResource: 'news',
    newsAcceptanceResource: 'newsAcceptance',
    // newsAcceptancesWithNewsCriteria: {'where': '{"GroupID":{"!":[4,8,16,22,23,24,40,42,50,52,54]}}', 'sort': 'Name asc'}

    taskResource: 'task',
    taskBoardsResource: 'taskBoard',
    taskBoardsMemebersResource: 'taskBoardsMemebers',

    finixBankResource: 'finixBank'

    // apiVer: 'v1.0/'
    // ajaxRequestTimeout: 5000 //5 sec
  }
}

export default {
  state: {
    appSettings: appSettings
  },
  getters: {
    appSettings: state => state.appSettings
  },
  mutations: {
    serverHostSet (state, newServerHostName) {
      state.appSettings.server.hostName = newServerHostName
      state.appSettings.server.host = state.appSettings.server.hosts[newServerHostName]
      state.appSettings.company = state.appSettings.companies[newServerHostName]
      if (state.appSettings.company != null) state.appSettings.company.config = state.appSettings.companiesConfigs[newServerHostName]
    }
  }
}



// WEBPACK FOOTER //
// ./src/settings.js